var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.38659,
    y: 1.86804,
    width: 24.6434,
    height: 40.5293,
    rx: 2.24031,
    stroke: "white",
    strokeWidth: 2.85131
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9515,
    y: 19.995,
    width: 24.6434,
    height: 40.5293,
    rx: 2.24031,
    stroke: "white",
    strokeWidth: 2.85131
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.38659,
    y: 49.119,
    width: 24.6434,
    height: 11.4052,
    rx: 2.24031,
    stroke: "white",
    strokeWidth: 2.85131
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9515,
    y: 1.86804,
    width: 24.6434,
    height: 11.4052,
    rx: 2.24031,
    stroke: "white",
    strokeWidth: 2.85131
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.032 9.60742C15.032 17.182 11.0323 22.7944 5.23975 22.7944C11.1243 22.7944 15.032 27.4487 15.032 34.6582C15.032 27.4031 18.4799 22.7944 24.1806 22.7944C18.5259 22.7944 15.032 17.0451 15.032 9.60742Z",
    stroke: "white",
    strokeWidth: 2.85131
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7729 61.3378C36.5288 52.8695 43.9158 36.0887 59.4164 36.7112M40.407 61.3378C41.7812 58.3929 47.5069 52.604 59.4164 53.0068",
    stroke: "white",
    strokeWidth: 2.85131
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionSix);
export default __webpack_public_path__ + "static/media/iconMissionSix.a04dd1850872533e565ceb2762668838.svg";
export { ForwardRef as ReactComponent };